// extracted by mini-css-extract-plugin
export default {"skeleton":"J9yr7","root":"okYbK","image":"xrfw2","credit":"IhTNj","coin":"vfoXZ","disabled":"HUM03","selected":"xlgj0","price":"hj955"};